import gsap from 'gsap'
import tailwindConfig from '../../../tailwind.config'

const screenLG  = tailwindConfig.theme.screens.lg.replace('px', '')

export default function(){
	const expandables = document.querySelectorAll('[data-name="expandable"]');

	if ( expandables.length > 0 && window.innerWidth >= screenLG ) {
		// Start posistion and get heightest title.
		let tallestTitle = 0;
		expandables.forEach(expandable => {
			const expandableTitle   = expandable.querySelector( '[data-name="expandable-visible"]' );
			const expandableWrapper = expandable.querySelector( '[data-name="expandable-wrapper"]' );

			if ( expandableTitle.offsetHeight > tallestTitle ) {
				tallestTitle = expandableTitle.offsetHeight
			}

			expandable.setAttribute( 'data-expandable-height', expandableWrapper.offsetHeight )
			gsap.set( expandableWrapper, { height: '0', autoAlpha: 0 } )
		})
		tallestTitle += 40;

		expandables.forEach(expandable => {
			expandable.style.height = tallestTitle + 'px'
		});

		expandables.forEach(expandable => {
			expandable.parentNode.addEventListener('mouseenter', function(){
				const expandableTitle   = expandable.querySelector( '[data-name="expandable-visible"]' );
				const expandableWrapper = expandable.querySelector( '[data-name="expandable-wrapper"]' );

				let expandableHeight = parseInt( expandable.getAttribute( 'data-expandable-height' ) ) + expandableTitle.clientHeight + 40;

				gsap.to( expandableWrapper, { height: 'auto', autoAlpha: 1, duration: 0.3 } )
				gsap.to( expandable, { height: expandableHeight, duration: 0.3 } )
			})
			expandable.parentNode.addEventListener('mouseleave', function(){
				const expandableWrapper = expandable.querySelector( '[data-name="expandable-wrapper"]' );

				gsap.to( expandableWrapper, { height: '0', autoAlpha: 0, duration: 0.3 } )
				gsap.to( expandable, { height: tallestTitle, duration: 0.3 } )

			})
		})
	}
}